import React from 'react';

const useWillUnmount = (effect: () => void, deps = []) => {
	React.useEffect(() => {
		return effect;
	}, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useWillUnmount };
